import request from '@/utils/request'

/**
 * 获取可用平台配置列表
 * @param {number} [platformType] 平台类型过滤（1-生视频，2-生图片，3-去字幕）
 * @returns {Promise}
 */
export function getPlatformConfigs(platformType) {
  return request({
    url: '/api/platform/config/list',
    method: 'get',
    params: platformType != null ? { platformType } : {}
  })
}


